<template>
  <span
    :is="type"
    :id="id"
    v-b-tooltip.hover="{ delay: { hide: 20 }, interactive: false }"
    :title="tooltip"
    class="al-icon"
    :type="type"
    :class="classes"
    test-id="al-icon"
    @click="onClick"
  ></span>
</template>
<script>
/**
 * Playvox icon definition
 * @displayName al-icon
 */
import { VBTooltip } from 'bootstrap-vue';

export default {
  name: 'AlIcon',
  directives: { 'b-tooltip': VBTooltip },
  props: {
    /**
     * Defined name of icon
     * @values
     */
    icon: {
      type: String,
      required: false,
      default: null
    },
    /**
     * Defined name of icon
     * @values
     */
    name: {
      type: String,
      default: ''
    },
    /**
     * Defined custom class for icon
     * @values
     */
    customClass: {
      type: String,
      default: null
    },
    /**
     * Defined what HTML tag will be rendered.
     * @values span, div
     */
    type: {
      type: String,
      default: 'span'
    },
    /**
     * Boolean flag to make the button small
     * @values true, false
     */
    isSmall: {
      type: Boolean
    },
    /**
     * Boolean flag to make the button extra small
     * @values true, false
     */
    isXs: {
      type: Boolean
    },
    color: {
      type: String,
      default: null
    },
    tooltip: {
      type: [Object, String],
      default: ''
    },
    id: {
      type: String,
      default: ''
    }
  },
  computed: {
    classes() {
      let theClass = '';
      if (this.name) {
        theClass = `al-icon-${this.name}`;
      }
      if (this.icon) {
        theClass = `icon icon-${this.icon}`;
      }
      if (this.customClass != null) {
        theClass = this.customClass;
      }
      if (this.color) {
        theClass = theClass.concat(' ', this.color);
      }
      return theClass;
    }
  },
  methods: {
    onClick(evt) {
      this.$emit('click', evt);
    },
    isBootstrap() {
      return this.icon;
    }
  }
};
</script>

<style lang="scss">
/**
 * Variables
 */
$font-size: 20px;
$w-content: 24px;
$h-content: $w-content;

$bg-warning: #ffc062;
$bg-danger: #c23e3e;
$bg-success: #12b981;
/**
* Styles for icons
*/
.icon,
.al-icon {
  align-items: center;
  display: inline-flex;
  font-size: $font-size;
  justify-content: center;
  //width: $w-content;
  //height: $h-content;

  &.warning {
    color: $bg-warning;
  }

  &.danger {
    color: $bg-danger;
  }

  &.success {
    color: $bg-success;
  }

  &::before {
    position: relative;
    top: 0;

    //      width: $w-content;
    //      height: $h-content;
  }
  /*
    &.is-small {
        width: $w-content - 8px;
        height: $h-content - 8px;
        font-size: $font-size - 8px;
    }

    &.is-xs {
        width: $w-content - 12px;
        height: $h-content - 12px;
        font-size: $font-size - 12px;
    }
*/
}
</style>
